import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles(theme => {
	const t = getTokens(theme.palette.type, theme.palette.primary.main);
	return {
		// O tema (App.js → overrides.MuiContainer) força padding lateral 0 e
		// maxWidth none com !important para manter as páginas antigas full-bleed.
		// Aqui o padding/limite é reafirmado também com !important — o sheet do
		// componente é injetado depois do tema, então vence.
		mainContainer: {
			flex: 1,
			width: "100%",
			minWidth: 0,
			padding: `${theme.spacing(3)}px !important`,
			height: `calc(100% - 48px)`,
			backgroundColor: t.page,
			boxSizing: "border-box",
			[theme.breakpoints.down("xs")]: {
				padding: `${theme.spacing(2)}px !important`,
			},
			// respiro do painel (.panel-main): 30px
			[theme.breakpoints.up("md")]: {
				padding: "30px !important",
			},
		},
		// Limite de largura vai no wrapper interno (o tema zera maxWidth do
		// Container com !important); centralizado com margin auto.
		limited: {
			width: "100%",
			maxWidth: 1280,
			marginLeft: "auto",
			marginRight: "auto",
		},
		contentWrapper: {
			height: "100%",
			overflowY: "hidden",
			display: "flex",
			flexDirection: "column",
			minWidth: 0,
			isolation: "isolate",
		},
		scrollPage: { display: "block", overflowY: "auto", overflowX: "hidden", paddingRight: 6, ...theme.scrollbarStyles },
		card: {
			backgroundColor: t.paper,
			border: `1px solid ${t.line}`,
			borderRadius: t.radius.md,
			boxShadow: t.shadow.card,
			overflow: "hidden",
		},
	};
});

/**
 * Container de página: fundo `page`, padding 24 (30 ≥ md).
 *
 * Props (todas opcionais — API anterior era só `children`):
 * - `maxWidth`: `true` | número → centraliza e limita a largura (1280 por padrão).
 *   Default: sem limite (telas largas como Tickets/Kanban não mudam).
 * - `card`: `true` → envolve o conteúdo em card branco (borda `line`, raio 8,
 *   sombra `card`). Default `false`, porque a maioria das páginas já usa Paper.
 *
 * `className` continua sendo aceito e ignorado, como antes (compatibilidade).
 */
const MainContainer = ({ children, maxWidth, card, scroll = false }) => {
	const classes = useStyles();

	const wrapperClass = [
		classes.contentWrapper,
		scroll ? classes.scrollPage : null,
		maxWidth ? classes.limited : null,
		card ? classes.card : null,
	]
		.filter(Boolean)
		.join(" ");

	const inlineMax =
		typeof maxWidth === "number" ? { maxWidth } : undefined;

	return (
		<Container
			className={`${classes.mainContainer} kp-page-shell`}
			data-kp-page-shell="true"
		>
			<div
				className={`${wrapperClass} kp-page-content${maxWidth ? " kp-page-content--limited" : ""}${card ? " kp-page-content--card" : ""}`}
				style={inlineMax}
			>
				{children}
			</div>
		</Container>
	);
};

export default MainContainer;
